import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VehicleGpsInfoComponent } from './vehicle-gps-info/vehicle-gps-info.component';

@NgModule({
    exports: [VehicleGpsInfoComponent],
    imports: [CommonModule],
    providers: [],
    declarations: [VehicleGpsInfoComponent]
})
export class SharedModule { }
